module.exports = __webpack_public_path__ + "static/img/comprehensive-img.e41d419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeaturesPhone/comprehensive-img.png
// module id = MA20
// module chunks = 0